import { Component} from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { objectify } from 'tslint/lib/utils';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent {
loader:boolean=false;
  name;
  pic: any;
  pic1: any;
  proof:boolean;
  Aproof:boolean;
  aproofId;
  numb;
  adproofName;
  proofObj:any;
  addsProof;
  idProofName;
  proofId;
  id;
  url;
  userObj:any;
  show:boolean;
  header;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
    public bottomSheet: MatBottomSheet,
    public santinzer: DomSanitizer,
    public platform: Platform) { }

      ionViewWillEnter(){
        this.loader = true;
        this.url = window.location.href.split('/');
        this.id = this.url.pop();
        if (this.url.includes('document-identity')){
          this.show = true;
          this.header = "Identity Section"
        }else if(this.url.includes('check-document')){
          this.show = true;
          this.header = "Identity Section"
        }else{
          this.show = false;
          this.header = "Address Proof"
        }
        this.service.getAddressById(this.id).subscribe(res => {
          this.userObj = res;
          if(this.userObj.userIdProof){
            if(this.userObj.userIdProof[0]){
              this.pic=this.userObj.userIdProof[0].img;
            }
         }
         if(this.userObj.userAddressProof){
           if(this.userObj.userAddressProof[0]){
            this.pic1=this.userObj.userAddressProof[0].img;
           }
        }         
        setTimeout(() => {
          this.idProof();
          this.AddressProof();
          this.loader=false;
        }, 1000);

        })
        
      }

      idProof(){
        this.service.getIdProof().subscribe(res => { 
          this.proofObj = res;
          if(this.userObj.userIdProof[0]){
            this.proofObj.map(res => {
              if (res.id == this.userObj.userIdProof[0].proofId) {
              this.idProofName = res.name;
              this.proofId = res.id;
              }
            })
          }
        })
      }
  
      AddressProof(){
        this.service.getAddressProof().subscribe(res => { 
          this.addsProof = res;
          if(this.userObj.userAddressProof[0]){
            this.addsProof.map(res => {
              if (res.id == this.userObj.userAddressProof[0].proofId) {
              this.adproofName = res.name;
              this.aproofId = res.id;
              }
            })
         }
        })
      }

      back(){
        if(this.url.includes('check-document') || this.url.includes('check-Address')){
          this.router.navigate(['/vendorAdminProfile'])
        }else{
        this.router.navigate(['vendorProfile/',this.id]);
        }
      }

      openBottomSheetAds(): void {    
        const dialogRef = this.bottomSheet.open(BottomSheet, {
          data:this.addsProof,
        });
        dialogRef.afterDismissed().subscribe((res) => {
          if(res){
            this.adproofName = res.name;
          this.aproofId = res.id;
          }
        });
      }


      openBottomSheet(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet, {
          data: this.proofObj,
        });
        dialogRef.afterDismissed().subscribe((res) => {
          if(res){
            this.idProofName = res.name;
            this.proofId = res.id;
          }
        });
      }

      handleFile(files,id) {
        if(id==1){
          var img = new Image();
          img.src = URL.createObjectURL(files[0]);
          img.onload = (data) => {
            var canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            this.pic = canvas.toDataURL('image/jpeg', 0.07);
          }
        }else{
          var img = new Image();
          img.src = URL.createObjectURL(files[0]);
          img.onload = (data) => {
            var canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            this.pic1 = canvas.toDataURL('image/jpeg', 0.07);
          }
        }
    
      }


   ionViewWillLeave(){
    this.idProofName = "";
    this.adproofName = "";
    this.userObj =[];
    this.pic = "";
    this.pic1 = "";
    }

     UpdateProfile(){
       this.loader=true;
      if((this.proofId&&this.pic) && this.show){
      var x ={
          "userId": this.id,
          "proofId": this.proofId,
          "img" : this.pic
        }
        if(!this.userObj.userIdProof){
          Object.assign(this.userObj,{userIdProof:[]})
          this.userObj.userIdProof.push(x)
        }else{
          this.userObj.userIdProof[0]=x
        }
        this.service.postProfileDetails(this.id,this.userObj).subscribe(res=>{
          this.handler.res('Profile Details Updated Successfully')
          this.loader=false;
          if(this.url.includes('check-document') || this.url.includes('check-Address')){
            this.router.navigate(['/vendorAdminProfile'])
          }else{
          this.router.navigate(['vendorProfile/',this.id]);
          }
         }, err => {
           this.loader=false;
          this.handler.err(err)
        })
     } else{
       this.handler.staticError('Please enter the required fields!!!!')
     }        
     if((this.aproofId&&this.pic1) && !this.show) {
          var y ={
            "userId": this.id,
            "proofId": this.aproofId,
            "img" : this.pic1
          }
          if(!this.userObj.userAddressProof){
            Object.assign(this.userObj,{userAddressProof:[]})
            this.userObj.userAddressProof.push(y)
          }else{
            this.userObj.userAddressProof[0]=y
          }
          this.service.postProfileDetails(this.id,this.userObj).subscribe(res=>{
            this.handler.res('Profile Details Updated Successfully')
            this.loader=false;
            if(this.url.includes('check-document') || this.url.includes('check-Address')){
              this.router.navigate(['/vendorAdminProfile'])
            }else{
            this.router.navigate(['vendorProfile/',this.id]);
            }
           }, err => {
             this.loader=false;
            this.handler.err(err)
          })
       } else{
        this.handler.staticError('Please enter the required fields!!!!')
      }
     
     }

}
